// .c-modal__box
let modal = {};
modal.initialized = false;

// data-gallery-slide
// data-image-url-view
// data-video-url-view
function makeModalGallery(){
    let gallery_list = [];
    let videos = [];

    if(typeof(modal.gallery) == "undefined"){
        modal.gallery = {};
        modal.gallery.initialized = false;
        modal.gallery.visible = false;
        modal.gallery.videos = [];
        modal.gallery.resize = function(){
            clearTimeout(modal.gallery.resize_to);
            modal.gallery.resize_to = setTimeout(function(){
                console.log("resize");
                if(modal.gallery.visible){
                    modal.gallery.swiper.update();
                }
            }, 16);

        };
        modal.gallery.resize_to = 0;
        modal.gallery.group = "";
    }

    modal.gallery.deinit = function(){
        modal.gallery.initialized = false;
        if(typeof(modal.gallery.swiper.destroy) == "function"){
            modal.gallery.swiper.destroy();
        }
    };

    modal.gallery.init = function(){
        let isSingle = $(".c-modal.c-modal--gallery .c-modal__box .swiper-slide").length == 1;
        if(isSingle){
            $(".c-modal.c-modal--gallery .c-slide__count").css("display", "none");
        }else{
            $(".c-modal.c-modal--gallery .c-slide__count").css("display", "flex");
        }
        modal.gallery.swiper = new Swiper(".c-modal.c-modal--gallery .c-modal__box", {
            slidesPerView: 1,
            spaceBetween: 0,
            watchOverflow: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            centeredSlides: true,
            preloadImages: false,
            updateOnWindowResize: false,
            speed: 500,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 4,
            },
            loop: !isSingle,
            loopedSlides: 2,
            navigation: {
                nextEl: ".c-modal.c-modal--gallery .c-slide__next",
                prevEl: ".c-modal.c-modal--gallery .c-slide__prev"
            },
            hashNavigation: {
                watchState: true,
            },
            pagination: {
                el: ".c-modal.c-modal--gallery .c-slide__count",
                type: "fraction",
                currentClass: "c-slide__count-current",
                totalClass: "c-slide__count-total",
                renderFraction: function (currentClass, totalClass) {
                    return '<div class="' + currentClass + '"></div><div class="' + totalClass + '"></div>';
                }
            },
            on: {
                init: function(){
                    console.log("INIT");
                    /* $(".swiper-slide video").each(function( index ) {
                        this.pause();
                        this.currentTime = 0;
                    }); */

                    return true;
                },
                hashSet: function(){
                    console.log("hash SET");
                }
            },
            breakpoints: {
                678: {
                    slidesPerView: isSingle?1:1.1
                },
                1024: {
                    slidesPerView: isSingle?1:1.2
                },
                1680: {
                    slidesPerView: isSingle?1:1.3
                }
            }
        });

        modal.gallery.swiper.on('slideChange', function(){
            console.log("Slide changed!");

            modal.gallery.videos.forEach(function( el ) {
                el.player.stop();
            });
        });

        /* modal.gallery.swiper.on('transitionEnd', function(){
            let vid = $(".c-modal__box .swiper-slide-active video");
            if(vid){
                vid.trigger("play");
            }
        }); */

        modal.gallery.swiper.on('hashChange', function(){
            console.log("HASH CHANGE", location.hash);
        });

        modal.gallery.initialized = true;
    };

    modal.gallery.filter = function(hashString){
        let grpArr = hashString.split('-');
        let grp = grpArr.length > 2?grpArr[1]:"";
        if(modal.gallery.group == grp) return false;
        console.log("Gallery FILTER: ", grp);
        modal.gallery.group = grp;
        modal.gallery.deinit();

        let hcode = "";
        gallery_list.filter(function(el){ return el.grp == modal.gallery.group}).forEach(function(e){
            if(e.video){
                if(e.src.match(/^http/g)){
                    let provider = "youtube";
                    if(e.src.match(/(vimeo)/g)) provider = "vimeo";
                    hcode += '<div class="c-modal__inner h-slide h-image-only swiper-slide" data-hash="'+e.hash+'"><div data-plyr-provider="'+provider+'" data-plyr-embed-id="'+e.src+'"></div></div>';
                }else{
                    hcode += '<div class="c-modal__inner h-slide h-image-only swiper-slide" data-hash="'+e.hash+'"><video poster="'+e.img+'" controls><source src="'+e.src+'" type="video/mp4""></video></div>';
                }
            }else{
                hcode += '<div class="c-modal__inner h-slide h-image-only swiper-slide" data-hash="'+e.hash+'"><img data-src="'+e.src+'" class="swiper-lazy"></div>';
            }
        });
        modal.gallery.videos = [];
        $(".c-modal.c-modal--gallery .swiper-wrapper").html(hcode);


        modal.gallery.init();


        $(".c-modal--gallery .swiper-slide div[data-plyr-embed-id], .c-modal--gallery .swiper-slide video").each(function (index, element) {
            let p = $(element).parent();
            modal.gallery.videos.push({hash: $(element).parent().data("hash") , parent: p, player: new Plyr(element)});
        });

        $(".c-modal--gallery .swiper-slide .plyr").each(function( index, element ) {
            let idx = modal.gallery.videos.findIndex(function(e){
                return e.parent.is($(element).parent());
            });
            if(idx >= 0) modal.gallery.videos[idx].el = $(element);
        });
    };

    if($(".c-modal.c-modal--gallery[data-src]").length > 0){
        $.ajax($(".c-modal.c-modal--gallery[data-src]").first().data("src")).done(function(msg){
            console.log("gallery data loaded");
            $(".c-modal.c-modal--gallery .swiper-wrapper").html(msg);
            modal.gallery.init();

            $(".c-modal--gallery .swiper-slide div[data-plyr-embed-id], .c-modal--gallery .swiper-slide video").each(function (index, element) {
                let p = $(element).parent();
                modal.gallery.videos.push({hash: $(element).parent().data("hash") , parent: p, player: new Plyr(element)});
            });

            $(".c-modal--gallery .swiper-slide .plyr").each(function( index, element ) {
                let idx = modal.gallery.videos.findIndex(function(e){
                    return e.parent.is($(element).parent());
                });
                if(idx >= 0) modal.gallery.videos[idx].el = $(element);
            });

            hashHandler();
        })
    }else{
        let gel = $("a[data-image-url-view][data-hash], a[data-video-url-view][data-hash]");
        if(gel.length <= 0) return false;

        let close = `
        <span class="close-gallery">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 37 36" style="enable-background:new 0 0 37 36;" xml:space="preserve">
            <style type="text/css">
                .st0c3{fill:none;stroke:#fff;stroke-miterlimit:10;}
            </style>
                <line class="st0c3" x1="1" y1="34.7" x2="35.3" y2="0.5"></line>
                <line class="st0c3" x1="35.3" y1="34.7" x2="1" y2="0.5"></line>
            </svg>
            <div class="circle"></div>
        </span>`
       

        if ($(".c-modal.c-modal--gallery").length == 0) {
            $("body").append($(`<div class="c-modal c-modal--gallery"><a class="c-modal__close js-toggle-modal" href="#">${close}</a><div class="c-modal__box swiper-container"><div class="swiper-wrapper"></div><!-- SLIDES GO HERE--></div><div class="c-slide__count"><div class="c-slide__count-current"></div><div class="c-slide__count-total"></div></div><a class="c-slide__prev" href="#">${TRANSLATIONS['ANKSTESNIS']}<svg x="0px" y="0px" viewBox="0 0 16.4 34.4" style="enable-background:new 0 0 16.4 34.4;"><polygon points="14,34.4 0,17.3 13.7,0 16.1,1.9 4,17.3 16.4,32.4"/></svg></a><a class="c-slide__next" href="#">${TRANSLATIONS['KITAS']}<svg x="0px" y="0px" viewBox="0 0 16.4 34.4" style="enable-background:new 0 0 16.4 34.4;"><polygon points="2.5,0 16.4,17.2 2.6,34.4 0.2,32.4 12.4,17.1 0.1,1.9"/></svg></a></div>`));
        }

        gel.each(function (index, element) {
            // element == this
            let d = $(element).data();
            let h = d.hash || "";
            let i = d.imageUrlView || "";
            let v = d.videoUrlView || "";
            let iu = d.imageUrl || "";
            let isVid = i == "";
            let garr = h.split('-');
            let group = garr.length > 2?garr[1]:"";
            if(gallery_list.filter(function(a){ return (a.hash == h && a.src == (isVid?v:i) && a.video == isVid); }).length == 0){
                gallery_list.push({
                    hash: h,
                    src: isVid?v:i,
                    img: iu,
                    video: isVid,
                    grp: group
                });
            }
        });

        let hcode = "";
        gallery_list.forEach(function(e){
            if(e.video){
                if(e.src.match(/^http/g)){
                    /* let q = "?";
                    if(e.src.match(/\?/g)) q = "&";
                    q += "enablejsapi=1"; */
                    let provider = "youtube";
                    if(e.src.match(/(vimeo)/g)) provider = "vimeo";
                    hcode += '<div class="c-modal__inner h-slide h-image-only swiper-slide" data-hash="'+e.hash+'"><div data-plyr-provider="'+provider+'" data-plyr-embed-id="'+e.src+'"></div></div>';
                }else{
                    hcode += '<div class="c-modal__inner h-slide h-image-only swiper-slide" data-hash="'+e.hash+'"><video poster="'+e.img+'" controls><source src="'+e.src+'" type="video/mp4""></video></div>';
                }
            }else{
                hcode += '<div class="c-modal__inner h-slide h-image-only swiper-slide" data-hash="'+e.hash+'"><img data-src="'+e.src+'" class="swiper-lazy"></div>';
            }
        });
        $(".c-modal.c-modal--gallery .swiper-wrapper").html(hcode);


        modal.gallery.init();

        $(".c-modal--gallery .swiper-slide div[data-plyr-embed-id], .c-modal--gallery .swiper-slide video").each(function (index, element) {
            let p = $(element).parent();
            modal.gallery.videos.push({hash: $(element).parent().data("hash") , parent: p, player: new Plyr(element)});
        });

        $(".c-modal--gallery .swiper-slide .plyr").each(function( index, element ) {
            let idx = modal.gallery.videos.findIndex(function(e){
                return e.parent.is($(element).parent());
            });
            if(idx >= 0) modal.gallery.videos[idx].el = $(element);
        });
    }
}

// Toggle modal
let lastScrollPos = 0;
$(document).on('click', '.js-toggle-modal', function (e) {
    let $this = $(this);
    let $hash = $this.data("hash") || "";
    if(typeof $this.data('title') !== 'undefined')  model_for_modal = JSON.parse('{"title":"'+$this.data('title')+'","type":"'+$this.data('type')+'","nicetitle":"'+$this.data('nicetitle')+'"}');

    if(!modal.initialized) modal.init();

    modal.videos = $(".c-modal video");
    modal.videos.each(function( index ) {
        this.pause();
        this.currentTime = 0;
    });
    lastScrollPos = window.pageYOffset;
    if(location.hash != $hash) location.hash = $hash;

    e.preventDefault();
});

let lastHash = "";

function hideOthers(str){
    if(str != "gallery" && modal.gallery) {
        modal.gallery.visible = false;
        if(modal.gallery.initialized) modal.gallery.swiper.keyboard.disable();
        modal.gallery.videos.forEach(function( el ) {
            el.player.stop();
        });
        $(".c-modal.c-modal--gallery").removeClass('h-is-active');
    }
}

function initModal(hash, id){
    if (!modal.initialized) modal.init();
    lastScrollPos = window.pageYOffset;
    if (location.hash != hash) location.hash = hash;
    Cookies.set('popup_' + id, '1');
}

function hashHandler(e){
    let loc = location.hash.replace("#", "");
    if(typeof(e) != "undefined"){
        if(loc == lastHash || loc == "") e.preventDefault();
    }
    lastHash = loc;
    //console.log("hash is changed to ", loc);
    let cls = "";
    let glr = {};
    if(loc == ""){
        hideOthers("");
        modal.videos = $(".c-modal video");
        modal.videos.each(function( index ) {
            this.pause();
            this.currentTime = 0;
        });

        $('body').removeClass('no-scroll');
        if(lastScrollPos != 0) window.scrollTo(0, lastScrollPos);
        $(".c-modal-bg").removeClass('h-is-active');
        $(".c-modal-bg").off("click");
        $(".c-modal").removeClass('h-is-active');
        return false;
    }

    let isSingle = loc.match(/^modal-/g) != null;

    if(loc.match(/^gallery-/g)) {
        hideOthers("gallery");
        cls = ".c-modal.c-modal--gallery";
        glr = modal.gallery;
        modal.gallery.filter(loc);
    }

    if((cls != "" && $(cls+' .swiper-wrapper .swiper-slide[data-hash="'+loc+'"]').length > 0) || isSingle){
        lastScrollPos = window.pageYOffset;
        $('body').addClass('no-scroll');
        setTimeout(function(){
            let vid = isSingle?false :$(cls+" .c-modal__box .swiper-slide-active .plyr");
            if(vid && vid.length > 0){
                let vids = modal.gallery.videos.filter(function(x){ return x.el.is(vid);});
                if(vids.length > 0){
                    vids[0].player.play();
                }
            }
        }, 500);
        $(".c-modal-bg").addClass('h-is-active');
        $(cls).addClass('h-is-active');
        glr.visible = true;
        if(!isSingle && glr.initialized) glr.swiper.keyboard.enable();
        glr.resize();
    }else{
        if(!isSingle && glr.initialized) glr.swiper.keyboard.disable();
        modal.gallery.videos.forEach(function( el ) {
            el.player.stop();
        });
        $('body').removeClass('no-scroll');
        window.scrollTo(0, lastScrollPos);
        $(".c-modal-bg").removeClass('h-is-active');
        $(".c-modal-bg").off("click");
        $(".c-modal").removeClass('h-is-active');
    }
}


// ! RUN CODE
modal.init = function(){
    if($(".c-modal-bg").length==0){
        $("body").append('<div class="c-modal-bg"></div>');
    }
    makeModalGallery();
    modal.initialized = true;

    $(window).on("hashchange", hashHandler);
    hashHandler();

    window.addEventListener("resize", function(){
        if(modal.gallery) modal.gallery.resize();
    });

    document.addEventListener('keyup', function (e) {
        console.log(e.key);
        if(e.key == "Escape" && $(".c-modal-bg").hasClass('h-is-active')){
            location.hash = "";
        }
    });
};

$(document).ready( function(){
    if(location.hash.replace("#","") != ""){
        modal.init();
    }

    let inlines = $(".c-modal.c-modal--inline");
    inlines.each(function (index, element) {
        // element == this
        let el = $(element);
        let sw = el.find(".swiper-container");
        let first = true;
        let isSingle = sw.find(".swiper-slide").length == 1;
        if(isSingle){
            el.find(".c-slide__count").css("display", "none");
        }else{
            el.find(".c-slide__count").css("display", "flex");
        }
        if(el.length > 0){
            new Swiper(sw.get(0), {
                slidesPerView: 1,
                spaceBetween: 0,
                watchOverflow: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                centeredSlides: true,
                preloadImages: false,
                speed: 500,
                autoHeight: true,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 4,
                },
                autoplay: {
                    delay: 5000,
                },
                loop: !isSingle,
                loopedSlides: 2,
                navigation: {
                    nextEl: el.find(".c-slide__next").get(0),
                    prevEl: el.find(".c-slide__prev").get(0)
                },
                pagination: {
                    el: el.find(".c-slide__count").get(0),
                    type: "fraction",
                    currentClass: "c-slide__count-current",
                    totalClass: "c-slide__count-total",
                    renderFraction: function (currentClass, totalClass) {
                        return '<div class="' + currentClass + '"></div><div class="' + totalClass + '"></div>';
                    }
                },
                on: {
                    slideChange: function(){
                        if(first){
                            first = false;
                            return false;
                        }
                        setTimeout(function(){
                            let c = el.find(".swiper-container-autoheight");
                            //let w = el.find(".swiper-wrapper");
                            let w = el.find(".swiper-slide-active");
                            console.log(c.height(), w.height());
                            c.height(w.height());
                        }, 100);
                    }
                },
                breakpoints: {
                    678: {
                        slidesPerView: isSingle?1:1.1,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: isSingle?1:1.2,
                        spaceBetween: 50
                    },
                    1680: {
                        slidesPerView: isSingle?1:1.3,
                        spaceBetween: 100
                    }
                }
            });
        }
    })
});